<template>
  <div>
    <ThirdBind v-if="isShow" @close="handelClose" :argument="argument" />
    <ThirdLoginBindPhone
      v-if="showThirdLoginBindPhone"
      @close="handelCloseBindPhone"
      :argument="bindPhoneArgument"
    />
  </div>
</template>

<script>
import ThirdBind from "@/pages/dialog/ThirdBindDialog.vue";
import ThirdLoginBindPhone from "@/pages/dialog/ThirdLoginBindPhone.vue";
export default {
  name: "auth",
  metaInfo() {
    return {
      title: this.$t("global.授权") + " | MANA",
    };
  },
  data() {
    return {
      code: "",
      state: "",
      isShow: false,
      showThirdLoginBindPhone: false,
      argument: {},
      bindPhoneArgument: {},
    };
  },
  components: {
    ThirdBind,
    ThirdLoginBindPhone,
  },
  computed: {
    peopleMessage() {
      return this.$store.state.peopleMessage;
    }
  },
  created() {
    this.state = this.$query.state;
    this.code = this.$query.code;
    switch (this.state) {
      case "qq_login":
        this.authLogin("qqCallback");
        break;
      case "weibo_login":
        this.authLogin("weiboCallback");
        break;
      case "wechat_login":
        this.authLogin("oauthCallback");
        break;
      case "qq_bind":
        this.authBind("qqBindCallback");
        break;
      case "weibo_bind":
        this.authBind("weiboBindCallback");
        break;
      case "wechat_bind":
        this.authBind("oauthBindCallback");
        break;
    }
  },
  methods: {
    /**
     * $t('global.三方登录')
     * $t('global.老账号') isNew = 0
     * 1.$t('global.老账号')  => $t('global.是否绑定手机号') => $t('global.已绑定手机号') => $t('global.验证昵称重复否')  => $t('global.不重复') => $t('global.登录')
     * 2.$t('global.老账号')  => $t('global.是否绑定手机号') => $t('global.已绑定手机号') => $t('global.验证昵称重复否')  => $t('global.重复') => $t('global.修改昵称页面') => $t('global.登录')
     * 3.$t('global.老账号')  => $t('global.是否绑定手机号') => $t('global.未绑定手机号') => $t('global.绑定手机号页面')
     * 4.$t('global.老账号')  => $t('global.绑定手机号页面') => $t('global.手机号存在') => $t('global.手机号已绑定微信') => $t('global.绑定失败'),提示文案：$t('global.这个手机号已经绑定其他微信用户')  => login
     * 5.$t('global.老账号')  => $t('global.绑定手机号页面') => $t('global.手机号存在') => $t('global.手机号未绑定微信') => $t('global.绑定失败'),提示文案：$t('global.这个手机号已经绑定其他账户') => login
     * 6.新账号  => $t('global.绑定手机号页面') => 手机号不存在 => 将手机号绑定到该账号
     * 7.$t('global.老账号')  => 手机号绑定完 => $t('global.昵称重复') => $t('global.修改昵称页面') => $t('global.登录')
     *
     * 新账号 isNew = 1;
     * 1.新账号  => $t('global.绑定手机号页面') ( 还未登录,无token,带什么信息过去绑定??? )
     * 2.新账号  => $t('global.绑定手机号页面') => $t('global.手机号存在') => $t('global.手机号已绑定微信') => $t('global.绑定失败')，提示文案：$t('global.这个手机号已经绑定其他微信用户')  => $t('global.绑定失败'),不能登录
     * 3.新账号  => $t('global.绑定手机号页面') => $t('global.手机号存在') => $t('global.手机号未绑定微信') => 把第三方账号绑定到该手机号的账号上，不生成新账号
     * 4.新账号  => $t('global.绑定手机号页面') => 手机号不存在 => $t('global.创建新账号'),$t('global.绑定手机')
     * 5.新账号  => 手机号绑定完 => $t('global.昵称重复') => $t('global.修改昵称页面') => $t('global.登录')
     */
    authLogin(action) {
      this.$http
        .get(`/api/passport/${action}`, {
          params: {
            code: this.code,
            state: this.state,
          },
        })
        .then((response) => {
          if (response.code === "OK") {
            const regData = response.data;
            this.bindPhoneArgument.params = regData;
            if (regData.isNew) {
              //$t('global.新用户')
              this.showThirdLoginBindPhone = true;
              this.bindPhoneArgument.isNew = true;
            } else {
              //老用户
              if (regData.mobile || regData.email) {
                //$t('global.已绑定手机号')
                if (regData.nickRepetition) {
                  //$t('global.昵称重复')
                  this.$message(
                    `${this.$t("global.昵称重复")},${this.$t(
                      "global.请修改昵称"
                    )}`
                  );
                  setTimeout(() => {
                    this.$router.push(
                      `/setInfo/nickname?userId=${response.data.userId}&login=true`
                    );
                  }, 1000);
                } else {
                  //$t('global.昵称不重复') , $t('global.登录')
                  const url = `/api/passport/loginThird`;
                  this.$http
                    .post(url, {
                      userId: response.data.userId,
                      token: response.data.token,
                      unionId: response.data.unionId,
                    })
                    .then((res) => {
                      if (res.code === "OK") {
                        let token = res.data.token;
                        localStorage.setItem("auth_token", token);
                        this.$http.get("/api/u/info/get").then((response) => {
                          this.$store.dispatch("setNewState", {
                            peopleMessage: response.data,
                            accountUser: response.data,
                            isLogin: true,
                          });
                          localStorage.setItem("isLogin", "true");
                          if (
                            localStorage.getItem("redirecturl") &&
                            localStorage.getItem("redirecturl") != ""
                          ) {
                            window.location.href = localStorage.getItem(
                              "redirecturl"
                            );
                          } else {
                            this.$router.replace("/");
                          }
                        });
                      }
                    });
                }
              } else {
                //$t('global.未绑定手机号')
                this.showThirdLoginBindPhone = true;
                this.bindPhoneArgument.isNew = false;
              }
            }
          } else {
            this.$message({
              message: this.$t("global.链接已经失效"),
              type: "warning",
            });
            setTimeout(() => {
              this.$router.push('/manageCenter?step=1')
            }, 1000);
          }
        });
    },
    authBind(action) {
      this.$http
        .get(`/api/passport/${action}`, {
          params: {
            code: this.code,
            state: this.state,
          },
        })
        .then((response) => {
          if (response.code === "OK") {
            this.$message({
              message: this.$t("global.绑定成功"),
              type: "success",
            });
            setTimeout(() => {
              this.$router.push('/manageCenter?step=1')
            }, 1000);
          } else if (response.code === "501") {
            const accountBinding = response.data.accountBinding;
            const userAccount = response.data.userAccount;
            const nickname = this.peopleMessage.nickname;
            const cancelObj = {
              p: [
                `${
                  action === "oauthBindCallback"
                    ? this.$t("global.微信")
                    : action === "weiboBindCallback"
                    ? this.$t("global.微博")
                    : action === "qqBindCallback"
                    ? "QQ"
                    : ""
                } ${accountBinding.nickname} ${this.$t(
                  "global.已经被绑定到账号"
                )} 「 ${userAccount.nickName} 」这个账号。`,
                `${this.$t("global.你可以选择将该")}${
                  action === "oauthBindCallback"
                    ? this.$t('global.微信')
                    : action === "weiboBindCallback"
                    ? this.$t('global.微博')
                    : action === "qqBindCallback"
                    ? "QQ"
                    : ""
                }${this.$t("global.从")}「${userAccount.nickName}」${this.$t(
                  "global.账号中解绑"
                )}，${this.$t("global.并绑定到当前账号")}「 ${nickname} 」。`,
              ],
              h: [],
            };
            cancelObj.h.push(
              `${this.$t("global.解绑后")}，${this.$t(
                "global.你将无法再通过该微信登录原账号"
              )}「${userAccount.nickName}」。`
            );
            if (!userAccount.mobile && !userAccount.email) {
              cancelObj.h.unshift(
                `${this.$t("global.原账号")}「${
                  userAccount.nickName
                }」${this.$t("global.未绑定任何手机号和邮箱")}。${this.$t(
                  "global.解绑后"
                )}，${this.$t("global.原账号")}「${
                  userAccount.nickName
                }」${this.$t("global.将永远无法再登录")}。`
              );
            }
            this.argument.cancelObj = cancelObj;
            this.argument.client =
              action === "oauthBindCallback"
                ? "wechat"
                : action === "weiboBindCallback"
                ? "weibo"
                : action === "qqBindCallback"
                ? "qq"
                : "";
            this.argument.openId = accountBinding.openId;
            this.argument.unionId = accountBinding.unionId;
            this.isShow = true;
          } else {
            this.$router.push('/manageCenter?step=1')
          }
        });
    },
    handelClose() {
      this.isShow = false;
      setTimeout(() => {
        this.$router.push('/manageCenter?step=1')
      }, 1000);
    },
    handelCloseBindPhone() {
      this.showThirdLoginBindPhone = false;
      setTimeout(() => {
        this.$router.push('/manageCenter?step=1')
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/passport/auth.vue